import { useCountUp } from '../hooks/useCountUp';
import { formatCompact, formatNumber } from '../services/format';

const LOGO_SOURCES = { sm: '/brand/logo-96.webp', md: '/brand/logo-192.webp', lg: '/brand/logo-512.webp' } as const;
const LOGO_SIZES = { sm: 40, md: 96, lg: 220 } as const;

export function LogoPlate({ size = 'sm', adaptive = false }: { size?: keyof typeof LOGO_SOURCES; adaptive?: boolean }) {
  const pixels = LOGO_SIZES[size];
  return (
    <span className={`logo-plate logo-plate--${size}${adaptive ? ' logo-plate--adaptive' : ''}`}>
      <img src={LOGO_SOURCES[size]} alt="ANIDEX" width={pixels} height={pixels} />
    </span>
  );
}

export function AnimaIcon({ size = 20 }: { size?: number }) {
  const source = size > 64 ? '/brand/anima-256.webp' : size > 28 ? '/brand/anima-96.webp' : '/brand/anima-48.webp';
  return <img className="anima-icon" src={source} width={size} height={size} alt="" aria-hidden="true" />;
}

export function AnimaAmount({ value, size = 18, signed = false, animate = false, compact = false }: { value: number; size?: number; signed?: boolean; animate?: boolean; compact?: boolean }) {
  const shown = useCountUp(value, animate);
  const sign = signed && value > 0 ? '+' : '';
  return (
    <span className="anima-amount">
      <AnimaIcon size={size} />
      <span className="anima-amount__value" aria-hidden={animate || compact || undefined}>
        {sign}
        {compact && shown >= 1_000_000 ? formatCompact(shown) : formatNumber(shown)}
      </span>
      {(animate || compact) && <span className="visually-hidden">{formatNumber(value)}</span>}
      <span className="visually-hidden"> Anima</span>
    </span>
  );
}

export function FragmentIcon({ size = 18 }: { size?: number }) {
  return <img className="fragment-icon" src="/brand/fragment-crystal.svg" width={size} height={size} alt="" aria-hidden="true" />;
}
